export default "__VITE_ASSET__DOUh6xlu__"